
import { Component, Prop, Ref, Vue, Watch, } from 'vue-property-decorator';

function getAncestorForm(element: HTMLElement) {
	let currentElement = element as HTMLElement | null;
	while (currentElement !== null) {
		currentElement = currentElement.parentElement;
		if (currentElement instanceof HTMLFormElement) {
			return currentElement;
		}
	}
	return null;
}

@Component
export default class FeedbackArticle extends Vue {
	isAffirmative = 'FIRST_APPEARANCE';
	showSomethingElse = false;
	checkedValues = [];
	enabledSubmitBtn = false;

	submitHandler?: (e: Event) => void;

	@Ref('container')
	container!: HTMLDivElement;

	@Prop({
		type: Array,
		required: true,
	})
	reasons!: string[];

	@Prop({
		type: String,
		required: true,
	})
	id!: string;

	@Watch('checkedValues')
	enableSubmitButton(newValue: []) {
		if (newValue.length > 0) {
			this.enabledSubmitBtn = true;
		} else {
			this.enabledSubmitBtn = false;
		}
	}

	get ancestorForm() {
		return getAncestorForm(this.container);
	}

	makeId(suffix: string) {
		return `${this.id}-${suffix}`;
	}

	mounted() {
		const ancestorForm = this.ancestorForm;
		if (ancestorForm === null) {
			return;
		}

		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const that = this;
		this.submitHandler = function (this: HTMLFormElement, e: Event) {
			e.preventDefault();
			e.stopImmediatePropagation();

			// eslint-disable-next-line @typescript-eslint/no-this-alias
			const form = this;

			fetch(form.action, {
				method: form.method,
				body: new FormData(form),
			}).catch(() => { /* swallow */ }).finally(() => {
				that.isAffirmative = 'NEGATIVE_MESSAGE';
			});
		};

		ancestorForm.addEventListener('submit', this.submitHandler);
	}

	unmounted() {
		const ancestorForm = this.ancestorForm;
		if (ancestorForm === null) {
			return;
		}

		if (this.submitHandler !== undefined) {
			ancestorForm.removeEventListener('submit', this.submitHandler);
		}
	}
}

